export default __webpack_public_path__ + "static/media/profile_icon_image.2b9ae393.png";